import styled from "styled-components";
import { GeometryType } from "@evergis/api";
import line from "../assets/compound_line.svg";
import point from "../assets/compound_point.svg";
import polygon from "../assets/compound_poly.svg";

export const compoundIconsMap = {
  polyline: line,
  point,
  polygon,
  multipolygon: polygon,
  h3grid: polygon,
};

export const CompoundIcon = styled.div<{ geometryType: GeometryType }>`
  background: ${({ geometryType }) =>
    `url(${compoundIconsMap[geometryType]}) center center / ${
      geometryType === GeometryType.Polygon ? "2rem 1.3rem" : "auto 1rem"
    } no-repeat`};
  height: 32px;
  width: 32px;
`;
